<ng-container *ngFor="let usageType of this.usageTypes$ | async">
  <ng-container *ngIf="usageType.technicalName === 'EU-Access'">
    <ng-container *ngIf="transactionTypeTexts$ | async as transactionTypeTexts">
      <div
        class="w-100 separator mt-4 mb-5"></div>
      <div class="row mt-5">
        <div
          class="col-12 col-sm-4 col-lg-4">
          <h3
            class="m-0 mb-4 d-flex flex-column justify-content-center min-input-height--sm ds-color--grey-2 ds-body">
            {{ transactionTypeTexts.euAccess }}
          </h3>
        </div>
        <div class="col-12 col-sm-8 col-lg-8 m-0 mb-4 d-flex justify-content-start align-items-center">
          <ds-switch [on]="'configurator.on' | cxTranslate"
                     [off]="'configurator.off' | cxTranslate"
                     [formControl]="formControl">
          </ds-switch>
          <ds-tooltip
            [ariaLabel]="'configurator.euAccessTooltip' | cxTranslate"
            [content]="'configurator.euAccessTooltip' | cxTranslate"
            class="ds-tooltip"
          ></ds-tooltip>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
